import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pt from 'vuetify/es5/locale/pt';
import es from 'vuetify/es5/locale/es';
import en from 'vuetify/es5/locale/en';
import { applyBrandTokens } from '@/design-system/theme/brand';
import { VUETIFY_LOCALE_MAP, readStoredLocale } from '@/constants/locale-constants';

Vue.use(Vuetify);

// Ripple Material desligado globalmente: a marca troca o feedback de press por
// mudança de COR, não por onda. O Vuetify registra suas diretivas globalmente
// em install.js, então sobrescrever depois do Vue.use() alcança todos os
// componentes. O CSS do DS também esconde .v-ripple__container como reforço.
// Para reativar num ponto específico: <v-btn :ripple="true">.
Vue.directive('ripple', { inserted() {} });

export function buildThemePalette(themeSection = {}) {
  return {
    primary: themeSection.primary,
    secondary: themeSection.secondary,
    terciary: themeSection.tertiary,
    accent: themeSection.accent,
    info: themeSection.info,
    warning: themeSection.warning,
    warningText: themeSection.warningText,
    error: themeSection.error,
    success: themeSection.success,
    backgroundPrimary: themeSection.background?.primary,
    backgroundSecondary: themeSection.background?.secondary,
    customerExchangeBankWorkflowStatusCadastroEnviado:
      themeSection.workflowStatus?.customer?.cadastroEnviado?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroEmAndamento:
      themeSection.workflowStatus?.customer?.cadastroEmAndamento?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroEmAndamentoText:
      themeSection.workflowStatus?.customer?.cadastroEmAndamento?.tonal?.text,
    customerExchangeBankWorkflowStatusCadastroFinalizado:
      themeSection.workflowStatus?.customer?.cadastroFinalizado?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroEmAnalise:
      themeSection.workflowStatus?.customer?.cadastroEmAnalise?.tonal?.chip,
    customerExchangeBankWorkflowStatusPendenciaDocumental:
      themeSection.workflowStatus?.customer?.pendenciaDocumental?.tonal?.chip,
    customerExchangeBankWorkflowStatusEnviadoAoBanco:
      themeSection.workflowStatus?.customer?.enviadoAoBanco?.tonal?.chip,
    customerExchangeBankWorkflowStatusPldCompliance:
      themeSection.workflowStatus?.customer?.pldCompliance?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroAprovado:
      themeSection.workflowStatus?.customer?.cadastroAprovado?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroRecusado:
      themeSection.workflowStatus?.customer?.cadastroRecusado?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroRecusadoText:
      themeSection.workflowStatus?.customer?.cadastroRecusado?.tonal?.text,
    customerExchangeBankWorkflowStatusAtualizacaoCadastral:
      themeSection.workflowStatus?.customer?.atualizacaoCadastral?.tonal?.chip,
    customerExchangeBankWorkflowStatusEncerrado:
      themeSection.workflowStatus?.customer?.encerrado?.tonal?.chip,
    customerExchangeBankWorkflowStatusPendenciaBanco:
      themeSection.workflowStatus?.customer?.pendenciaBanco?.tonal?.chip,
    customerExchangeBankWorkflowStatusCadastroAprovadoText:
      themeSection.workflowStatus?.customer?.cadastroAprovado?.tonal?.text,
    operationWorkflowStatusEmAnalise:
      themeSection.workflowStatus?.operation?.emAnalise?.tonal?.chip,
    operationWorkflowStatusComPendencias:
      themeSection.workflowStatus?.operation?.comPendencias?.tonal?.chip,
    operationWorkflowStatusAnalisePendencias:
      themeSection.workflowStatus?.operation?.analisePendencias?.tonal?.chip,
    operationWorkflowStatusEmLiquidacao:
      themeSection.workflowStatus?.operation?.emLiquidacao?.tonal?.chip,
    operationWorkflowStatusLiquidada:
      themeSection.workflowStatus?.operation?.liquidada?.tonal?.chip,
    operationWorkflowStatusCancelada:
      themeSection.workflowStatus?.operation?.cancelada?.tonal?.chip,
    colorSell: themeSection.error,
    colorBuy: themeSection.success,
    colorAuditRemove: themeSection.audit?.remove,
    colorAuditAdd: themeSection.audit?.add,
    dividerPanel: themeSection.divider?.panel,
    emptyState: themeSection.table?.emptyState,
    bankTypeStandardChip: themeSection.bankType?.standard?.tonal?.chip,
    bankTypeStandardText: themeSection.bankType?.standard?.tonal?.text,
    bankTypeSignatureChip: themeSection.bankType?.signature?.tonal?.chip,
    bankTypeSignatureText: themeSection.bankType?.signature?.tonal?.text,
    bankTypeAutomaticChip: themeSection.bankType?.automatic?.tonal?.chip,
    bankTypeAutomaticText: themeSection.bankType?.automatic?.tonal?.text,

    documentUploadAreaBorder: themeSection.documentUpload?.area?.border,
    documentUploadAreaBackground: themeSection.documentUpload?.area?.background,
    documentUploadAreaBackgroundHover: themeSection.documentUpload?.area?.backgroundHover,
    documentUploadAreaBackgroundDragOver: themeSection.documentUpload?.area?.backgroundDragOver,
    documentUploadAreaBackgroundHasFile: themeSection.documentUpload?.area?.backgroundHasFile,
    documentUploadAreaBorderDragOver: themeSection.documentUpload?.area?.borderDragOver,
    documentUploadAreaBorderHasFile: themeSection.documentUpload?.area?.borderHasFile,
    documentUploadAreaText: themeSection.documentUpload?.area?.text,
    documentUploadAreaTextSecondary: themeSection.documentUpload?.area?.textSecondary,
    documentUploadExistingAreaBorder: themeSection.documentUpload?.existingDocument?.area?.border,
    documentUploadExistingAreaBackground: themeSection.documentUpload?.existingDocument?.area?.background,
    documentUploadExistingContentBackground: themeSection.documentUpload?.existingDocument?.content?.background,
    documentUploadExistingIconWrapperBackground: themeSection.documentUpload?.existingDocument?.iconWrapper?.background,
    documentUploadExistingNameText: themeSection.documentUpload?.existingDocument?.name?.text,
    documentUploadExistingStatusText: themeSection.documentUpload?.existingDocument?.status?.text,
    notificationSuccessBorder: themeSection.notifications?.success?.border,
    notificationSuccessBackground: themeSection.notifications?.success?.background,
    notificationSuccessText: themeSection.notifications?.success?.text,
    notificationInformationBorder: themeSection.notifications?.information?.border,
    notificationInformationBackground: themeSection.notifications?.information?.background,
    notificationInformationText: themeSection.notifications?.information?.text,
    notificationWarningBorder: themeSection.notifications?.warning?.border,
    notificationWarningBackground: themeSection.notifications?.warning?.background,
    notificationWarningText: themeSection.notifications?.warning?.text,
    notificationErrorBorder: themeSection.notifications?.error?.border,
    notificationErrorBackground: themeSection.notifications?.error?.background,
    notificationErrorText: themeSection.notifications?.error?.text,
    timelinePhaseSketch: themeSection.timeline?.phaseSketch,
    timelinePhasePayin: themeSection.timeline?.phasePayin,
    timelinePhasePayout: themeSection.timeline?.phasePayout,
    timelinePhaseOperation: themeSection.timeline?.phaseOperation,
    timelinePhaseCommission: themeSection.timeline?.phaseCommission,
    timelineStep1: themeSection.timeline?.step1,
    timelineStep2: themeSection.timeline?.step2,
    timelineStep3: themeSection.timeline?.step3,
    timelineStep4: themeSection.timeline?.step4,
    timelineStep5: themeSection.timeline?.step5,
    timelineStep6: themeSection.timeline?.step6,
    timelineStep7: themeSection.timeline?.step7,
    timelineStep8: themeSection.timeline?.step8
  };
}

export function createVuetify(theme) {
  if (!theme?.data) {
    throw new Error('Theme data is required to create Vuetify instance.');
  }

  const { light, dark } = theme.data;

  // Tokens de marca (--tc-action e derivados) a partir do primary do tenant.
  // O app abre no tema claro, então o primary ativo e o canônico coincidem aqui;
  // depois disso quem mantém a sincronia é installBrandSync (main.js).
  // O acento do menu é o declarado no theme.json; sem ele, o derivado da marca.
  applyBrandTokens(light?.primary, light?.primary, {
    darkPrimary: dark?.primary,
    accent: light?.accent
  });

  return new Vuetify({
    lang: {
      // Os idiomas do seletor; o atual vem do salvo, para o F5 não voltar ao português
      locales: { pt, es, en },
      current: VUETIFY_LOCALE_MAP[readStoredLocale()] || 'pt'
    },
    theme: {
      options: {
        customProperties: true,
        variations: true
      },
      themes: {
        light: buildThemePalette(light),
        dark: buildThemePalette(dark)
      }
    }
  });
}

/**
 * Re-injeta os tokens de marca depois de trocar de tema (claro/escuro) ou de
 * tenant. Precisa ser chamado porque --tc-action e derivados são calculados a
 * partir do primary vigente, e o primary muda nos dois casos.
 *
 * @param {object} vuetify  instância do Vuetify ($vuetify)
 */
export function syncBrandTokens(vuetify) {
  const variant = vuetify?.theme?.dark ? 'dark' : 'light';
  const primary = vuetify?.theme?.themes?.[variant]?.primary;

  // O shell sempre vem do primary canônico — ver deriveShell em theme/brand.js.
  return applyBrandTokens(primary, vuetify?.theme?.themes?.light?.primary, {
    darkPrimary: vuetify?.theme?.themes?.dark?.primary,
    accent: vuetify?.theme?.themes?.[variant]?.accent
  });
}
